const Paypal ={
    Login: {
        HEADER: "Log in to Discover to link your account",
        SECURE_MESSAGE: "Secure Account Log In",
        BUTTON: "Log In",
        UNABLE_TO_LINK_ERROR_OVERLAY: "We were unable to link your account. Sorry, something went wrong. ",        
    },
    SingleCard: {
        HEADER: "Confirm this is the account you'd like to link with PayPal",
        MESSAGE: "By selecting \"Link Now\" you are agreeing to the below Terms.",
        BUTTON: "Link Now",
        LINK: "Cancel",
        TERMS : "Terms & Conditions"
    },
    MultiCard: {
        HEADER: "Select the cards you'd like to link with PayPal",
        MESSAGE: "By selecting \"Link Now\" you are agreeing to the below Terms.",
        BUTTON: "Link Now",
        LINK: "Cancel",
        TERMS : "Terms & Conditions"
    },
    MaxProvisioningLimit: {
        HEADER: "You've linked your card(s) to the maximum allowed PayPal Accounts.",
        MESSAGE1: "We cannot link your card(s) at this time. For your security, you can add a Discover Card to a maximum of ",
        MESSAGE2: " PayPal Accounts. Please remove your card(s) from at least one PayPal account, before retrying.",
        LINK: "Cancel"
    },
    NoEligibleCard: {
        HEADER: "We were unable to link your account",
        MESSAGE: "Sorry, you do not have an eligible card to link.",
        LINK: "Cancel"
    },
    TechDiff: {
        HEADER: "We were unable to link your account",
        MESSAGE: "Sorry, something went wrong. Please try to link your account again.",
        LINK: "Cancel"
    },
    AccountAlreadyLinked: {
        HEADER: "You're ready to go with PayPal",
        MESSAGE: "Would you like to make Discover your preferred card on PayPal?",
        BUTTON: "Set as Preferred",
        LINK: "Not Now"
    },
    TryLinkingAgain: {
        HEADER: "We were unable to link your account",
        MESSAGE: "Sorry, something went wrong. Please try to link your account again.",
        LINK: "Cancel"
    }
}

const Amazon ={
    Login: {
        HEADER: "Log in to Discover to add your card",
        SECURE_MESSAGE: "Secure Account Log In",
        BUTTON: "Log In",
        UNABLE_TO_LINK_ERROR_OVERLAY: "We were unable to add your card. Sorry, something went wrong. "
    },
    SingleCard: {
        HEADER: "Add Card to Amazon.com",
        MESSAGE: "By selecting \"Add Card\" you are agreeing to the below Terms.",
        BUTTON: "Add Card",
        LINK: "Cancel",
        TERMS : "Terms & Conditions"
    },
    MultiCard: {
        HEADER: "Select the card you'd like to add to Amazon.com",
        MESSAGE: "By selecting \"Add Card\" you are agreeing to the below Terms.",
        BUTTON: "Add Card",
        LINK: "Cancel",
        TERMS : "Terms & Conditions"
    },
    MaxProvisioningLimit: {
        HEADER: "We were unable to add your card",
        MESSAGE1: "We cannot add your card(s) at this time. You can add a Discover Card to a maximum of ",
        MESSAGE2: " Amazon Accounts. Please remove your card(s) from at least one Amazon account, before retrying.",
        LINK: "Cancel and return to Amazon"
    },
    NoEligibleCard: {
        HEADER: "We were unable to add your card",
        MESSAGE: "Sorry, you do not have an eligible card to add.",
        LINK: "Cancel and return to Amazon"
    },
    TechDiff: {
        HEADER: "We were unable to add your card",
        MESSAGE: "Sorry, something went wrong. Please try to add your card again.",
        LINK: "Cancel and return to Amazon"
    },
    AccountAlreadyLinked: {
        HEADER: "You're ready to go with Amazon.com",
        BUTTON: "Start Shopping on Amazon"
    },
    TryLinkingAgain: {
        HEADER: "We were unable to add your card",
        MESSAGE: "Sorry, something went wrong. Please try to add your card again.",
        LINK: "Cancel and return to Amazon"
    }
}

const Default ={
    Login: {
        HEADER: "Log in to Discover to add your card",
        SECURE_MESSAGE: "Secure Account Log In",
        BUTTON: "Log In",
        UNABLE_TO_LINK_ERROR_OVERLAY: "We were unable to add your card. Sorry, something went wrong. ",
    }
}

export const getMerchantData = merchantName =>{
    if (merchantName === "paypal") {
        return Paypal
    }else if (merchantName === "amazon"){
        return Amazon
    }else {
        merchantName = capitalizeMerchantName(merchantName)
        return {
            Login: {
                HEADER: "Log in to Discover to add your card",
                SECURE_MESSAGE: "Secure Account Log In",
                BUTTON: "Log In",
                UNABLE_TO_LINK_ERROR_OVERLAY: "We were unable to add your card. Sorry, something went wrong. "
            },
            SingleCard: {
                HEADER: `Add Card to ${merchantName}`,
                MESSAGE: `By Selecting "Add Card", you agree to share this account information with ${merchantName}.`,
                BUTTON: "Add Card",
                LINK: `Cancel and return to ${merchantName}`
            },
            MultiCard: {
                HEADER: `Select the cards you'd like to add to ${merchantName}`,
                MESSAGE: `By selecting "Add Card", you agree to share this account information with ${merchantName}.`,
                BUTTON: "Add Card",
                LINK: `Cancel and return to ${merchantName}`
            },
            MaxProvisioningLimit: {
                HEADER: "We were unable to add your card",
                MESSAGE1: "We cannot add your card(s) at this time. For your security, you can add a Discover Card to a maximum of ",
                MESSAGE2:  `Amazon Accounts. Please remove your card(s) from at least one ${merchantName} account, before retrying.`,
                Link: `Cancel and return to ${merchantName}`
            },
            NoEligibleCard: {
                HEADER: "We were unable to add your card",
                MESSAGE: "Sorry, you do not have an eligible card to add.",
                LINK: `Cancel and return to ${merchantName}`
            },
            TechDiff: {
                HEADER: "We were unable to add your card",
                MESSAGE: "Sorry, something went wrong. Please try to add your card again.",
                LINK: `Cancel and return to ${merchantName}`
            },
            AccountAlreadyLinked: {
                HEADER: `You're ready to go with ${merchantName}`,
                MESSAGE: `Would you like to make Discover your default card on ${merchantName}?`,
                BUTTON: "Set as Default",
                LINK: "Not Now"
            },
            TryLinkingAgain: {
                HEADER: "We were unable to add your card",
                MESSAGE: "Sorry, something went wrong. Please try to add your card again.",
                LINK: `Cancel and return to ${merchantName}`
            }
        }
    }
}

export const getMerchantDataLoginPage = merchantName =>{
    if (merchantName === "paypal") {
        return Paypal
    }else if (merchantName === "amazon"){
        return Amazon
    }else {
        return Default
    }
}

export const capitalizeMerchantName = merchantName => {
    return merchantName.charAt(0).toUpperCase() + merchantName.slice(1);
}

export const onUserCancel = data =>{
    if (data.merchantName === "paypal"){
        return (
          window.location.replace(data.cancelUrlData+ '?error=USER_CANCELED')
          );
    }else{
        return (
          window.location.replace(data.cancelUrlData)
          );
       }
    }

export const onServerError = data =>{
    if (data.merchantName === "paypal"){
        return (
          window.location.replace(data.cancelUrlData+ '?error=INTERNAL_SERVER_ERROR')
        );
      }else{
        return (
          window.location.replace(data.cancelUrlData)
          );
        }
    }

    export const unProcessableEntity = data =>{
        if(data.merchantName === "paypal"){
            return (
              window.location.replace(data.cancelUrlData+'?error=UNPROCESSABLE_ENTITY')
            );
          }
          else{
            return (
              window.location.replace(data.cancelUrlData)
              );
            }
    }

    export const setPreferedUrl = data =>{
            return(
            window.location.replace(data.setAsPrefered)
           );
    }

    export const formatPhoneNumber = phoneNumberString => {
        var cleanedString = ('' + phoneNumberString).replace(/\D/g, '')
        var matchFormat = cleanedString.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (matchFormat) {
          var internationalCode = (matchFormat[1] ? '+1' : '')
          return [internationalCode, '(', matchFormat[2], ') ', matchFormat[3], '-', matchFormat[4]].join('')
        }

        return ""
      }

    export const isRealPhoneNumber = phoneNumberString => {
        if(phoneNumberString.slice(0,3) !== "000")
            return true
        else
            return false
    }
     
